import { Directive, Input } from '@angular/core';
import { DirectiveSuperclass } from '@sama/ng-core';
import { AbstractSensorContentState } from '../../../../state/abstract-sensor-content-state';
import { AbstractSensorContentStore } from '../../../../state/abstract-sensor-content-store';
import { AbstractTool } from '../../abstract-tool';

@Directive()
export abstract class AbstractSecondaryToolbar<
  A extends AbstractSensorContentState = AbstractSensorContentState,
  T extends AbstractSensorContentStore<A> = AbstractSensorContentStore<A>,
  ThisTool extends AbstractTool<A, T> = AbstractTool<A, T>,
> extends DirectiveSuperclass {
  @Input({ required: true }) tool!: ThisTool;
}
